// source: src/common/datasync/data_sync.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.loupe.common.datasync.DataSyncStatus', null, global);
/**
 * @enum {number}
 */
proto.loupe.common.datasync.DataSyncStatus = {
  DATA_SYNC_STATUS_UNSPECIFIED: 0,
  DATA_SYNC_STATUS_NOT_CONFIGURED: 1,
  DATA_SYNC_STATUS_PAUSED: 2,
  DATA_SYNC_STATUS_PENDING: 3,
  DATA_SYNC_STATUS_ACTIVE: 4,
  DATA_SYNC_STATUS_ERROR: 5,
  DATA_SYNC_STATUS_READY: 6
};

goog.object.extend(exports, proto.loupe.common.datasync);
